<div class="content-with-filled-button">
    <h2 class="sub-title offset-inline" id="generalTitle">
        {{copyService.copies.request_entity_subtitle}}
    </h2>
    <br>
    <div class="checkbox">
        <voxel-radio-button-group id="radioLiveAbroad">
            <voxel-radio-button *ngFor="let selectionList of listRequestLoan" [id]="'radioButtonID' + selectionList.name"
             [checked]="selectionList.id === requestEntitySelected" (radioButtonChange)="selectRequestLoan(selectionList.id)" 
             [value]="selectionList.name">
                {{selectionList.name}}
            </voxel-radio-button>
          </voxel-radio-button-group>
    </div>
</div>
<app-controls [hasPrevious]="true" [nextLabel]="copyService.copies.loan_agreements.button"
    [nextDisabled]="isBtnDisabled" (next)="next()"></app-controls>